import { parseSpanish, isLive, type SpanishPageData } from '@/lib/spanishFormat';

/** Spanish pages, one markdown file each; see src/lib/spanishFormat.ts. */
const files = import.meta.glob('./*.md', { query: '?raw', import: 'default', eager: true }) as Record<string, string>;

export const spanishPages: SpanishPageData[] = Object.entries(files).map(([file, src]) => parseSpanish(src, file));

export const getSpanish = (path: string) => spanishPages.find((p) => p.path === path);

/** English path -> Spanish path, for reviewed pages only (the language switch). */
export const spanishFor = (englishPath: string) =>
  spanishPages.find((p) => isLive(p) && p.translationOf === englishPath)?.path;
